
import { MDBAlert, MDBBtn, MDBFile, MDBInput, MDBModalFooter, MDBSelect, MDBSpinner } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { uploadGreeting } from "../../apiclients/streamsapi_bridge";

export default function UploadMedia(props) {

    const { t, i18n } = useTranslation();
    const [errorflag, setErrorflag] = useState(false);
    const [uploadedAudioPath, setUploadedAudioPath] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [greetingType, setGreetingType] = useState(3);
    const [disableDone, setDisableDone] = useState(true);
    const [failedErrorMessage, setFailedErrorMessage] = useState("");
    const [isloading, setIsloading] = useState(false);
    const [uploadName, setUploadName] = useState("");
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (uploadName == null || selectedFile == null || uploadName == '' || selectedFile == '') {
            setDisableDone(true);
        } else {
            setDisableDone(false);
        }
    }, [uploadName, selectedFile]);

    useEffect(() => {
        if (props.isActive) {
            setErrorflag(false);
            setUploadedAudioPath("");
            setSelectedFile(null);
            setGreetingType(3);
            setDisableDone(true);
            setFailedErrorMessage("");
            setUploadName("");
            setErrorMessage('');

        }

    }, [props.isActive]);


    // On Choose File
    const handleFileUpload = (eventData) => {
        setErrorflag(false);
        // setDisableDone(eventData.target.files.length == 0 ? true : false);
        eventData.stopPropagation();
        const file = eventData.target.files?.[0];
        if (file) {
            const fileUrl = URL.createObjectURL(file);
            // verifying the weather the file  if mp3 / wav file or not
            let fileext = file.name.split(".")[1];
            if (
                (fileext == undefined || !(fileext.includes("wav") || fileext.includes("mp3"))) ||
                file.size / (1024 * 1024) >= 25
            ) {
                // setting the error and returning back the control.
                setErrorflag(true);
            }
            // removking existing audio path for memory leaks 
            if (uploadedAudioPath) {
                URL.revokeObjectURL(uploadedAudioPath);
            }

            setUploadedAudioPath(fileUrl);
            setSelectedFile(file);
        } else {
            setUploadedAudioPath("");
            setSelectedFile("");
        }
    };


    // New Greeting File upload.
    async function uploadFile() {
        try {
            setIsloading(true);
            const formData = new FormData();
            formData.append("siteid", JSON.parse(sessionStorage.getItem("admin_session")).siteid); // The account siteId.
            formData.append("logined_user", JSON.parse(sessionStorage.getItem("admin_session")).logined_user);
            formData.append("greeting_type", greetingType); //  greeting type need to be updated.
            formData.append("greeting", selectedFile); //  file object or the streams data.
            formData.append("filename", selectedFile.name); // Name of the file.
            formData.append("filetype", "." + selectedFile.name.split(".")[1]); //  type of the file either wav or mp3
            formData.append("uploadtype", 1); // either file upload or microphone upload 1- file 2- microphone
            formData.append("name", uploadName);

            let apiResponse = await uploadGreeting(formData);
            setTimeout(() => { setIsloading(false) }, 1000);
            let resdata = await apiResponse.json();
            if (apiResponse.status == 200) {
                localStorage.setItem("s_message", resdata.message); // successfully uploaded.
                props.onClose();
                window.location.href = "/medialanding";
            } else if (apiResponse.status === 204 || apiResponse.status === 403 || apiResponse.status === 400 || apiResponse.status === 500) {
                setFailedErrorMessage(resdata.message);
            } else {
                localStorage.setItem("f_message", resdata.message);
                props.onClose();
                window.location.href = "/medialanding";
            }
            console.log(`uploadFile -> JSON Response:${JSON.stringify(resdata)}`);

        } catch (error) {
            console.log(`Unable to upload the file:${error}`);
            setFailedErrorMessage('Internal Server Error');
        }

    }

    const handleInputChange = (event) => {
        const { value } = event.target;
        const fileNameRegex = /^.{1,30}$/;
        if (value.trim() === "") {
            setErrorMessage("Name is required.");
            setUploadName(null);
        } else if (!fileNameRegex.test(value)) {
            setErrorMessage("The name is invalid. It must not exceed a maximum number of 30 characters.");
            setUploadName(null);
        } else {
            setUploadName(value);
            setErrorMessage('');
        }
    };

    return (
        <>
            {/* <div class="tel-numbers"><strong>{t("Greeting_Type_txt")}</strong></div>
            <MDBSelect
                data={[
                    { text: 'MOH_IVR', value: 3 },
                    { text: 'IVR Greeting', value: 4 },
                    { text: 'Announcement Greeting', value: 5 },
                ]}
                value={greetingType}
                onChange={(e) => setGreetingType(e.value)}
            /> */}

            <div class="tel-numbers mt-2"><strong>Name:<span className='text-danger'>*</span></strong></div>
            <div className=' d-flex align-items-center'>
                <div className='w-100 my-2'>
                    <MDBInput
                        label="Name"
                        maxLength={30}
                        value={uploadName}
                        onChange={handleInputChange}
                    />
                    {errorMessage && <p className="text-danger">{errorMessage}</p>}
                </div>
            </div>

            <div class="tel-numbers mt-2"><strong>{t("MediaFile")}</strong></div>
            <div>
                <MDBFile id="customFile" onChange={handleFileUpload} />
                <span className="text-secondary">{t("maxuploadsize")}</span>
                {errorflag && (
                    <div className="text-danger">{t("fileUploadErrorMsg")}</div>
                )}
            </div>
            {errorflag == false && uploadedAudioPath && (
                <div className="audio-controls-hunt py-2 d-flex align-items-center">
                    <audio src={uploadedAudioPath} controls></audio>
                </div>
            )}
            <MDBModalFooter className="mt-2">
                <MDBBtn color='secondary' onClick={props.onClose}>
                    {t("close")}
                </MDBBtn >
                <MDBBtn disabled={disableDone}
                    onClick={(e) => {
                        e.preventDefault();
                        uploadFile();
                    }}>{t("Done")}</MDBBtn>
            </MDBModalFooter>
            {failedErrorMessage !== "" && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setFailedErrorMessage("")}
                >
                    {failedErrorMessage}
                </MDBAlert>
            )}
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
        </>
    );


}